<template>
  <div class="p-1">
    <div
      v-for="(item, ind) in listSubMenuMarketing"
      :key="ind"
      :style="{
        color: activeTab === item.id ? '#0d6efd' : 'black',
      }"
      class="cursor-pointer d-flex align-items-center font-weight-bold"
      @click="handleClick(item)"
      style="gap: 10px; padding: 10px 4px"
    >
      <feather-icon :icon="item.icon" size="18" />
      <span>{{ item.title }}</span>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BIcon,
  BRow,
  BButton,
  BFormInput,
  BAvatar,
} from "bootstrap-vue";
import useToastHandler from "@/services/toastHandler";
import { formatTime } from "@/helpers/utils";
import {
  marketingSidebarMenu,
} from "@/@core/utils/enum/sidebar";

export default {
  components: {
    BIcon,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BAvatar,
  },
  data() {
    return {
      activeTab: 1,
      listSubMenuMarketing: this.marketingSidebarMenu,
    };
  },
  computed: {},
  watch: {},
  async mounted() {},
  methods: {
    handleClick(item) {
      this.activeTab = item.id;
      this.$router.push(item.route);
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();

    return {
      showToastError,
      showToastSuccess,
      formatTime,
      marketingSidebarMenu,
    };
  },
};
</script>

<style scoped></style>
